import { render, staticRenderFns } from "./PersonSetDealerForm.vue?vue&type=template&id=e304cf34&"
import script from "./PersonSetDealerForm.vue?vue&type=script&lang=js&"
export * from "./PersonSetDealerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports